/**
 * The Privacy Policy, readable without signing in (issue #56; checklist C-14 in
 * `policies/PLAID_SECURITY_QUESTIONNAIRE.md`).
 *
 * ONE COPY OF THE TEXT. The page is built from `policies/PRIVACY_POLICY.md`
 * itself, imported at build time, so the policy the reviewer approves is the
 * policy the page shows and there is no second copy to keep in step. A change
 * to that file is a change to this page.
 *
 * PUBLIC, like /login and /signup: Plaid's questionnaire asks for a link to it,
 * and a person deciding whether to sign up reads it before they have an
 * account. It sits outside the shell, as those pages do.
 */

import policy from '../../../../policies/PRIVACY_POLICY.md?raw';
import { renderMarkdown } from '../lib/markdown.js';

export function PrivacyPage() {
  return (
    <main className="document">
      <article>{renderMarkdown(policy)}</article>
      <p className="muted">
        <a href="/">Back to Techne Books</a>
      </p>
    </main>
  );
}
